import {IFluxStandardAction} from '@fkhplus/common/src/modules/interfaces';

const actionTypePrefix = 'network/';

export const NetworkActionTypes = {
    IS_CONNECTED : `${actionTypePrefix}IS_CONNECTED`,
  };

export type NetworkPayload = boolean | string;  

export const networkConnection = (payload: boolean): IFluxStandardAction<boolean>  => {
  return {
    type: NetworkActionTypes.IS_CONNECTED,
    payload
  };
};
